import { Link, LinkProps } from "react-router-dom";

type Props = LinkProps;

export const ButtonLink = (props: Props) => <Link {...props} className={["btn", props.className].join(" ")} />;
